<template>
  <div id="app">
    <router-view />
    <footer class="page-footer">
      <div class="gobeyonddev-footer-logo-container">
      </div>
      <div class="footer-row">
        &copy; {{ new Date().getFullYear() }} GoBeyond Software Development
        <br>
        <a href="/faq" class="footer-link"><span class="nowrap">FAQ</span></a>
        &nbsp;|&nbsp;
        <router-link to="/about-me" class="footer-link"><span class="nowrap">About</span></router-link>
        &nbsp;|&nbsp;
        <a href="/contact" class="footer-link"><span class="nowrap">Contact</span></a>
      </div>
      <div class="footer-row">
        <router-link to="/privacy-policy" class="footer-link"><span class="nowrap">Privacy Policy</span></router-link>
        &nbsp;|&nbsp;
        <router-link to="/terms" class="footer-link"><span class="nowrap">Terms of Service</span></router-link>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Quicksand', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.page-footer {
  width: 100%;
  text-align: center;
  font-size: 1rem;
  color: #888;
  background: transparent;
  padding: 12px 0 12px 0;
  margin-top: 0px;
  letter-spacing: 0.01em;
  position: static;
}
#app > .page-footer {
  margin-top: auto;
}
body {
  padding-bottom: 0;
}
.footer-link {
  color: #7da47e;
  text-decoration: underline;
  font-weight: 500;
}
.footer-row {
  display: block;
  margin: 2px 0;
}
.footer-link:hover {
  color: #388E3C;
}
.nowrap {
  white-space: nowrap;
}
.gobeyonddev-footer-logo-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 32px 0 10px 0;
}
.footer-gobeyonddev-link {
  display: inline-flex;
  align-items: center;
}
.gobeyonddev-logo {
  height: 141px;
  width: auto;
  display: block;
}
@media (max-width: 700px) {
  .gobeyonddev-logo {
    max-width: 105px;
    width: 53vw;
    height: auto;
    object-fit: contain;
    display: block;
    margin: 0 auto 0 auto;
  }
  .gobeyonddev-footer-logo-container {
    margin: 18px 0 0 0;
  }
}
</style>
